import { render, staticRenderFns } from "./WordMark.vue?vue&type=template&id=64b84f27&scoped=true&"
import script from "./WordMark.vue?vue&type=script&lang=js&"
export * from "./WordMark.vue?vue&type=script&lang=js&"
import style0 from "./WordMark.vue?vue&type=style&index=0&id=64b84f27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b84f27",
  null
  
)

export default component.exports